var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _path0, _circle3, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4189 23.2422V43.1088",
    stroke: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5049 25.2289L27.7035 22.9395",
    stroke: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.043 33.6719V43.6052",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0098 33.1758L24.0098 43.6058",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4189 23.7383V43.6049",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1289 24L29.1289 29.3536",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0563 33.1761H11.5996C11.0473 33.1761 10.5996 32.7284 10.5996 32.1761V23.2428V23.2428C10.5996 22.9685 10.822 22.7461 11.0963 22.7461H17.0563M17.0563 33.1761H24.5062M17.0563 33.1761V22.7461M17.0563 22.7461H23.5062C24.0585 22.7461 24.5062 23.1938 24.5062 23.7461V26.2228",
    stroke: "#313131"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3679 27.7105C15.3679 28.4484 15.1675 29.0939 14.87 29.5403C14.57 29.9902 14.2106 30.1905 13.8812 30.1905C13.5518 30.1905 13.1924 29.9902 12.8924 29.5403C12.5948 29.0939 12.3945 28.4484 12.3945 27.7105C12.3945 26.9725 12.5948 26.327 12.8924 25.8806C13.1924 25.4308 13.5518 25.2305 13.8812 25.2305C14.2106 25.2305 14.57 25.4308 14.87 25.8806C15.1675 26.327 15.3679 26.9725 15.3679 27.7105Z",
    stroke: "#313131"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9442 38.3393C32.4542 37.8427 31.694 37.3291 30.3802 32.6773C28.9775 27.7106 25.0042 26.2206 21.5276 25.2273C19.5585 24.6648 17.4669 29.6973 20.9436 30.6907C25.0238 31.8564 24.5076 34.664 25.5009 38.6373C26.2956 41.816 28.9775 43.604 32.4542 44.1006",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8614,
    cy: 41.1212,
    r: 2.97666,
    stroke: "#313131"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9814 15.793V22.7396C27.9814 23.2919 28.4292 23.7396 28.9814 23.7396H37.9081C38.4604 23.7396 38.9081 23.2919 38.9081 22.7396V15.793",
    stroke: "#313131"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4443,
    cy: 19.7646,
    r: 1.98333,
    stroke: "#313131"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3323 9.92848L33.3326 9.92868C33.3325 9.92862 33.3324 9.92855 33.3323 9.92848L33.447 9.76463L33.3323 9.92848ZM33.447 10.0088L41.7941 15.8518H25.0999L33.447 10.0088Z",
    stroke: "#313131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.083 33.1758V43.6058",
    stroke: "#313131",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.68e01fc52144551c1b4871d80d741edc.svg";
export { ForwardRef as ReactComponent };